import { Component, OnDestroy, OnInit } from '@angular/core';
import { AttachmentService } from '../../../Attachment/attachment.service';
import { PopUpService } from '../../../Common/Popup/popup.service';
import { PubSubService } from '../../../Common/Popup/pubsub.service';
import { DocumentService } from 'src/app/Documents/document.service';

@Component({
    selector: 'file-preview',
    templateUrl: './filePreview.component.html',
    standalone: false,
})
export class FilePreviewComponent implements OnInit, OnDestroy {
    constructor(
        private readonly _attachmentService: AttachmentService,
        private readonly _pubSubService: PubSubService,
        private readonly _popUpService: PopUpService,
        private readonly _documentService: DocumentService,
    ) {}

    file: File;
    fileInfo: any;
    attachmentID = null;
    attachmentFileName = null;
    attachmentFileExtension = null;
    previewSupported: boolean = false;
    fileError: boolean = false;

    private _pubSubSubscriptions = [];

    ngOnInit() {
        // subscribe to pub-sub to handle "attachmentChanged" messages
        const subscription = this._pubSubService.subscribe(
            this._popUpService.Topics.Attachment.AttachmentChanged,
            (data: any) => {
                this.loadAttachment(data.attachmentInfo);
            },
        );
        this._pubSubSubscriptions.push(subscription);

        // notify the caller that the preview is ready
        this._pubSubService.publishParent(this._popUpService.Topics.Attachment.PreviewInitialized);

        // File preview doesn't have a navbar; use CSS to selectively add/remove the top content padding as appropriate
        document.body.classList.remove('show-nav');
    }

    // clean up pub-sub subscription upon destroy
    ngOnDestroy(): void {
        let i = this._pubSubSubscriptions.length;
        while (i--) {
            this._pubSubSubscriptions[i].unsubscribe();
        }
    }

    downloadAttachment(): void {
        this._attachmentService.downloadAttachmentByGuid(
            this.attachmentID,
            this.attachmentFileName,
            this.attachmentFileExtension,
        );
    }

    async loadAttachment(attachmentInfo): Promise<void> {
        if (attachmentInfo.attachmentID !== this.attachmentID) {
            const { type, previewSupported } = this._attachmentService.getMimeTypeByFileExtension(
                attachmentInfo.fileExtension,
            );
            if (previewSupported) {
                try {
                    const response = await this._documentService.getDocumentBody(attachmentInfo.attachmentID);
                    const attachmentBlob = new Blob([response.body], { type: attachmentInfo.fileExtension });

                    this.attachmentID = attachmentInfo.attachmentID;
                    this.attachmentFileName = attachmentInfo.fileName;
                    this.attachmentFileExtension = attachmentInfo.fileExtension;

                    this.file = new File([attachmentBlob], this.attachmentFileName, { type });
                    this.previewSupported = previewSupported;

                    this.fileError = false;
                } catch (err) {
                    this._resetAttachment(attachmentInfo);
                    this.fileError = true;
                }
            } else {
                this._resetAttachment(attachmentInfo);
                this.fileError = false;
            }
        }
    }

    private _resetAttachment(attachmentInfo): void {
        this.attachmentID = attachmentInfo.attachmentID;
        this.attachmentFileName = attachmentInfo.fileName;
        this.attachmentFileExtension = attachmentInfo.fileExtension;
    }
}
